<template>
  <div>
    <v-layout row justify-end class="mt-2">
      <v-flex xs3>
        <multiselect
          style="margin-top: 3px"
          class="mr-0 mr-sm-2"
          @input="onSearch"
          v-model="selectCampaign"
          :options="campaign"
          label="label"
          placeholder="เลือก"
        ></multiselect>
      </v-flex>

      <v-flex xs9 class="ml-1">
        <InputSearch class="mb-3" :search="filter" @clickSearch="onSearch" :placeholder="'ค้นหา'" />
      </v-flex>
    </v-layout>

    <v-layout
      wrap
      class="mt-4"
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <v-flex xs6>
        <Typography h2 bold label="จำนวนการขอคูปอง" />
      </v-flex>

      <v-flex xs6 class="text-xs-right">
        <v-btn
          variant="outlined"
          v-tooltip="'ส่งออกข้อมูล'"
          @click="modalExport = true"
          :loading="loading"
          icon
          color="#BECCDB"
          style="border-radius: 50% !important"
        >
          <img src="/static/img/exportfilter.png" alt class="responsive-img" style="height: 16px" />
        </v-btn>
        <exportxlsx ref="exbtn" :value="exData" style="display: none"></exportxlsx>
      </v-flex>
    </v-layout>

    <!-- <v-layout row wrap justify-end class="ma-0 pa-0">
      <v-flex xs6 class="text-xs-right">
        <v-btn @click="exportData" :loading="loading" color="grey" outline>
          <i class="fas fa-file-export"></i>
          &nbsp;
          {{ $t('export') }}&nbsp;
        </v-btn>
        <exportxlsx ref="exbtn" :value="exData" style="display:none"></exportxlsx>
      </v-flex>
    </v-layout> -->

    <!-- <v-layout class="mb-0" row wrap justify-end>
      <v-flex class="form-control pa-1">
        <multiselect
          class="mr-0 mr-sm-2"
          @input="searchinput"
          v-model="selectCampaign"
          :options="campaign"
          label="campaignname"
          selectLabel
          selectedLabel
          placeholder="Campaign"
          :searchable="false"
          deselect-label
        ></multiselect>
      </v-flex>
    </v-layout> -->
    <div>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>

      <v-data-table
        v-else
        hide-actions
        :headers="selectCampaign.value === 'province' ? headersCouponReport : headers"
        :items="showData"
        item-key="name"
        :class="
          showData.length > 0 && selectCampaign.value === 'province'
            ? `fixTableProvince`
            : showData.length > 0 && selectCampaign.value === 'unit'
            ? `fixTable`
            : ''
        "
      >
        <template v-slot:headers="props">
          <tr style="background-color: #152d53; color: white">
            <th
              style="background-color: #152d53; color: yellow"
              v-for="header in props.headers"
              :key="header.text"
            >
              <div>{{ header.text }}</div>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr class="depatable">
            <td class="text-xs-left">
              <Typography style="width: 40px" h5 :label="props.index + 1" />
            </td>
            <td class="text-xs-left" v-if="selectCampaign.value === 'province'">
              <Typography style="width: 130px" h5 :label="props.item.province || '-'" />
            </td>
            <td class="text-xs-left">
              <Typography style="width: 300px" h5 :label="props.item.campaignname || '-'" />
            </td>
            <td class="text-xs-left">
              <Typography style="width: 300px" h5 :label="props.item.agencyname || '-'" />
            </td>
            <td class="text-xs-left">
              <Typography style="width: 150px" h5 :label="props.item.request || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 color="color-waiting" :label="props.item.pending || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 color="color-complete" :label="props.item.approve || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 color="color-error" :label="props.item.reject || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 color="color-error" :label="props.item.expire || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 color="color-mediumGrey" :label="props.item.cancel || 0" />
            </td>
            <td class="text-xs-left">
              <Typography h5 :label="props.item.couponresidual || 0" />
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="modalExport" persistent width="400px">
        <v-card style="border-radius: 10px">
          <div class="pa-3">
            <div style="display: flex; justify-content: space-between">
              <div></div>
              <div></div>

              <v-icon style="display: flex; align-items: center" @click="modalExport = false"
                >close</v-icon
              >
            </div>
            <div class="rsu">
              <v-layout column wrap justify-center align-center class="mb-3">
                <img
                  src="/static/img/Export.png"
                  alt
                  class="responsive-img mb-1"
                  style="height: 70px"
                />
                <Typography h2 bold label="ส่งออกข้อมูล" />
                <Typography h5 medium label="คุณแน่ใจหรือไม่ว่าต้องการส่งออกข้อมูลตามที่เลือก" />
              </v-layout>
              <div class="text-xs-center">
                <div class="text-xs-center rsu">
                  <v-btn
                    :loading="loading"
                    class="rsu"
                    round
                    small
                    outline
                    color="primary"
                    @click.stop="modalExport = false"
                    >ยกเลิก</v-btn
                  >
                  <v-btn
                    class="rsu"
                    :loading="loading"
                    round
                    small
                    depressed
                    style="color: #ffef01"
                    color="primary"
                    @click.stop="exportData"
                    >ยืนยัน</v-btn
                  >
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <Paginations
        @clickPagination="changepage"
        @sortPage="sortPage"
        :pageCount="pageCount"
        :numberPage="numberPage"
        :page="page"
      />
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import api from '@/api'
import config from '@/config'
import exportxlsx from '@/components/elements/exportxlsx.vue'

import Typography from '@/components/elements/Typography.vue'
import InputSearch from '@/components/elements/InputSearch.vue'
import Paginations from '@/components/elements/Paginations.vue'

export default {
  components: {
    Multiselect,
    datepicker,
    exportxlsx,
    Typography,
    InputSearch,
    Paginations,
  },
  data() {
    return {
      pagination: {
        sortBy: 'name',
        descending: false,
        rowsPerPage: 15,
      },
      selectCampaign: { label: 'ตามหน่วยร่วม', value: 'unit' },
      rowsPerPage: 12,
      filter: {
        campaign: null,
        dateFrom: null,
        dateTo: null,
        nameAll: '',
      },
      exData: [],
      exDataAll: [],
      page: 1,
      numberPage: {
        page: undefined,
      },
      loading: false,
      modalExport: false,
      campaign: [],
      mainData: [],
      showData: [],
      pageTotal: 0,
      topData: [],
      top5: [],
      topOther: [],
      tafficReport: {},
      topProduct: [],
      campaign: [
        {
          label: 'ตามหน่วยร่วม',
          value: 'unit',
        },
        {
          label: 'ตามจังหวัด',
          value: 'province',
        },
      ],
      headers: [
        { text: 'ลำดับ', align: 'left', value: 'id', sortable: false },
        { text: 'แคมเปญ', align: 'left', value: 'campaign', sortable: false },
        { text: 'ชื่อหน่วยร่วม', align: 'left', value: 'agency', sortable: false },
        { text: 'จำนวนการขอคูปอง', align: 'left', value: 'buyer', sortable: false },
        { text: 'รอตรวจสอบ', align: 'left', value: 'pending', sortable: false },
        { text: 'อนุมัติแล้ว', align: 'left', value: 'approve', sortable: false },
        { text: 'ไม่อนุมัติ', align: 'left', value: 'reject', sortable: false },
        { text: 'หมดอายุ', align: 'left', value: 'expire', sortable: false },
        { text: 'ยกเลิก', align: 'left', value: 'cancel', sortable: false },
        { text: 'คงเหลือ', align: 'left', value: 'asd', sortable: false },
      ],
      headersCouponReport: [
        { text: 'ลำดับ', align: 'left', value: 'id', sortable: false },
        { text: 'จังหวัด', align: 'left', value: 'province', sortable: false },
        { text: 'แคมเปญ', align: 'left', value: 'campaign', sortable: false },
        { text: 'ชื่อหน่วยร่วม', align: 'left', value: 'agency', sortable: false },
        { text: 'จำนวนการขอคูปอง', align: 'left', value: 'buyer', sortable: false },
        { text: 'รอตรวจสอบ', align: 'left', value: 'pending', sortable: false },
        { text: 'อนุมัติแล้ว', align: 'left', value: 'approve', sortable: false },
        { text: 'ไม่อนุมัติ', align: 'left', value: 'reject', sortable: false },
        { text: 'หมดอายุ', align: 'left', value: 'expire', sortable: false },
        { text: 'ยกเลิก', align: 'left', value: 'cancel', sortable: false },
        { text: 'คงเหลือ', align: 'left', value: 'asd', sortable: false },
      ],
    }
  },
  computed: {
    techhuntUrl() {
      return config.techhuntUrl
    },
    pageCount() {
      if (this.pageTotal !== 0) {
        let count = Math.ceil(this.pageTotal / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    },
  },
  mounted() {
    this.setup()
  },
  methods: {
    async getExDataAgencyWithCampaign() {
      this.loading = true
      let ex = []
      let filter = {}

      if (this.filter.nameAll) {
        filter.nameAll = this.filter.nameAll
      }

      // filter.limit = this.limitCom
      // filter.offset = this.offsetCom

      this.data = await api.getAgencyWithCampaign(filter)
      this.loading = false
      this.exDataAll = this.data.data ? this.data.data : []

      this.exDataAll.forEach((ele) => {
        let obj = {
          แคมเปญ: ele.campaignname,
          ชื่อหน่วยร่วม: ele.agencyname,
          จำนวนการขอคูปอง: ele.request || 0,
          อนุมัติแล้ว: ele.approve || 0,
          คงเหลือ: ele.couponresidual || 0,
        }
        ex.push(obj)
      })
      this.exData = ex
    },

    async getExDataCouponReport() {
      this.loading = true
      let ex = []
      let filter = {}
      if (this.filter.nameAll) {
        filter.nameAll = this.filter.nameAll
      }

      // filter.limit = this.limitCom
      // filter.offset = this.offsetCom

      this.data = await api.getProvinceCouponStat(filter)
      this.loading = false
      this.exDataAll = this.data.data ? this.data.data : []

      this.exDataAll.forEach((ele) => {
        let obj = {
          จังหวัด: ele.province,
          จำนวนการขอคูปอง: ele.request || 0,
          อนุมัติแล้ว: ele.approve || 0,
          คงเหลือ: ele.couponresidual || 0,
        }
        ex.push(obj)
      })

      this.exData = ex
    },
    async exportData() {
      this.loading = true
      if (this.selectCampaign.value === 'province') {
        await this.getExDataCouponReport()
      } else {
        await this.getExDataAgencyWithCampaign()
      }
      this.modalExport = false
      this.$refs.exbtn.exportxlsx()
      this.loading = false
    },
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      if (this.selectCampaign.value === 'province') {
        await this.getCouponReport()
      } else {
        await this.getAgencyWithCampaign()
      }
      this.loading = false
    },
    async sortPage(pages) {
      if (pages) {
        this.page = parseInt(pages)
        this.loading = true
        if (this.selectCampaign.value === 'province') {
          await this.getCouponReport()
        } else {
          await this.getAgencyWithCampaign()
        }
        this.loading = false
      }
    },
    shotDate(input) {
      return moment(input).format('DD/MM/YYYY')
    },
    async setup() {
      if (this.selectCampaign.value === 'province') {
        await this.getCouponReport()
      } else {
        await this.getAgencyWithCampaign()
      }
    },
    async onSearch() {
      this.page = parseInt(1)
      if (this.selectCampaign.value === 'province') {
        this.getCouponReport()
      } else {
        this.getAgencyWithCampaign()
      }
    },
    async getAgencyWithCampaign() {
      this.loading = true
      let filter = {}
      if (this.filter.nameAll) {
        filter.nameAll = this.filter.nameAll
      }
      if (this.limitCom) {
        filter.limit = this.limitCom
      }
      filter.offset = this.offsetCom

      this.data = await api.getAgencyWithCampaign(filter)
      this.loading = false
      this.showData = this.data.data ? this.data.data : []
      this.pageTotal = this.data.total ? this.data.total : []
    },
    async getCouponReport() {
      this.loading = true
      let filter = {}
      if (this.filter.nameAll) {
        filter.nameAll = this.filter.nameAll
      }
      if (this.limitCom) {
        filter.limit = this.limitCom
      }
      filter.offset = this.offsetCom

      this.data = await api.getProvinceCouponStat(filter)
      this.loading = false
      this.showData = this.data.data ? this.data.data : []
      this.pageTotal = this.data.total ? this.data.total : []
    },
    clickDetail(id) {
      window.open(`${config.techhuntUrl}product?id=${id}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 120px;
  min-height: 60px;
  background-color: #182748;
  color: white;
  text-align: center;
  align-self: center;
  font-weight: bold;
}
.flex-row-end {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.fixTableProvince table.v-table {
  thead {
    tr {
      th:nth-child(1) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0 !important;
        z-index: 2;
      }
      th:nth-child(2) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 64px !important;
        z-index: 3;
      }
      th:nth-child(3) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 218px !important;
        z-index: 2;
      }
      th:nth-child(4) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 542px !important;
        z-index: 1;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      th:nth-child(4)::after {
        content: '';
        border-right: 0;
      }
    }
  }
  tbody {
    tr {
      td:nth-child(1) {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        left: 0 !important;
        z-index: 2;
      }
      td:nth-child(2) {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        left: 64px !important;
        z-index: 3;
      }
      td:nth-child(3) {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        left: 218px !important;
        z-index: 2;
      }
      td:nth-child(4) {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        left: 542px !important;
        z-index: 1;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      td:nth-child(4)::after {
        content: '';
        border-right: 0;
      }
    }
  }
}
.fixTable table.v-table {
  thead {
    tr {
      th:nth-child(1) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0 !important;
        z-index: 2;
      }
      th:nth-child(2) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 64px !important;
        z-index: 3;
      }
      th:nth-child(3) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 388px !important;
        z-index: 2;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      th:nth-child(3)::after {
        content: '';
        border-right: 0;
      }
    }
  }
  tbody {
    tr {
      td:nth-child(1) {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        left: 0 !important;
        z-index: 2;
      }
      td:nth-child(2) {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        left: 64px !important;
        z-index: 3;
      }
      td:nth-child(3) {
        position: sticky !important;
        position: -webkit-sticky !important;
        background: #ffffff;
        left: 388px !important;
        z-index: 2;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      td:nth-child(3)::after {
        content: '';
        border-right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/voucherreport/byagecy.vue